import { render, staticRenderFns } from "./deanSidemenuColumn.vue?vue&type=template&id=092788f0&scoped=true"
import script from "./deanSidemenuColumn.vue?vue&type=script&lang=ts"
export * from "./deanSidemenuColumn.vue?vue&type=script&lang=ts"
import style0 from "./deanSidemenuColumn.vue?vue&type=style&index=0&id=092788f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092788f0",
  null
  
)

export default component.exports